import React, { useEffect, useRef, useState } from 'react';
// import sections
import Manifesto from '../components/sections/Manifesto';
import RoadmapCards from '../components/elements/RoadmapCards';
import Roadmap from '../components/sections/Roadmap';
import Team from '../components/sections/Team';
import Cta from '../components/sections/Cta';
import LandingPage from '../assets/images/LandingPage.webp';
import SchoolNight from '../assets/images/School_Night_Full.png';
import SchoolDayVideo from '../assets/videos/School-Day-Slow-1.m4v';
import SchoolDayImage from '../assets/images/School_Day_Full.png';
import LogoDay from '../assets/images/Logo_Day.png';
import LogoNight from '../assets/images/Logo_Night.png';
import BackgroundImage from '../components/elements/BackgroundImage';
import MoneyRain from '../components/elements/MoneyRain.js';
import Switch from '../components/elements/Switch';
import Fireflies from '../components/elements/Fireflies';
import FAQs from '../components/sections/FAQs';
import Hammer from '../components/elements/Hammer';
import { Link } from 'react-router-dom';
import FeaturedGameCard from '../components/elements/FeaturedGameCard';
import Kipon from '../assets/images/Kipon.webp';
import Robotrix from '../assets/images/Robotrix.webp';
import TreasureBox from '../assets/images/TreasureBox.webp';
import Developer3 from '../assets/images/Developer3.png';
import Jane from '../assets/images/Jane.png';
import OurGames from '../assets/images/OurGames.webp';

const Home = () => {
  const defaultLogoWidth = 800;
  const defaultLogoHeight = 450;
  const [logoWidth, setLogoWidth] = useState(Math.min(800, window.innerWidth * 0.4));
  const [logoHeight, setLogoHeight] = useState(Math.min(450, logoWidth * defaultLogoHeight/defaultLogoWidth));
  const [nightTime, setNightTime] = useState(false);
  const [dayAlpha, setDayAlpha] = useState(1);
  const [cloudsAlpha, setCloudsAlpha] = useState(1);

  {/** 
  useEffect(() => {
    const handleResize = () => {
      setBackgroundWidth(Math.max(window.innerWidth, (defaultBackGroundWidth * window.innerHeight/defaultBackGroundHeight)));
      setBackgroundHeight(Math.max(window.innerHeight, (defaultBackGroundHeight * window.innerWidth/defaultBackGroundWidth)));
      if(window.innerWidth/window.innerHeight > 3/2){
        setLogoWidth(window.innerWidth * 0.4);
        setLogoHeight(window.innerWidth * 0.4 * (defaultLogoHeight/defaultLogoWidth));
      }
      else if(window.innerWidth/window.innerHeight > 1){
        setLogoWidth(window.innerWidth * 0.5);
        setLogoHeight(window.innerWidth * 0.5 * (defaultLogoHeight/defaultLogoWidth));
      }
      else if(window.innerWidth/window.innerHeight > 3/4){
        setLogoWidth(window.innerWidth * 0.7);
        setLogoHeight(window.innerWidth * 0.7 * (defaultLogoHeight/defaultLogoWidth));
      }
      else{
        setLogoWidth(window.innerWidth * 0.75);
        setLogoHeight(window.innerWidth * 0.75 * (defaultLogoHeight/defaultLogoWidth));
      }
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    }
  });
  */}

  const showHammer = () => {
    if(!document.getElementById("build-school-button").disabled){
      document.getElementById("hammer").style.opacity = 1;
      document.getElementById("hammer").className = "hammer-visible";
      document.getElementById("build-school-button").disabled = true;
      setTimeout(() => {
        document.getElementById("hammer").style.opacity = 0;
        document.getElementById("hammer").className = "";
        document.getElementById("build-school-button").disabled = false;
      }, 5000);
    }
  }
  /*
  const handleScroll = () => {
    const scrollY = window.scrollY;
    console.log("ScrollY: " + scrollY + " Window ScrollY: " + window.scrollY);
    if(scrollPosition < scrollY){
      console.log("Scroll down");
      setScrollPosition();
    }
    else if(scrollPosition > scrollY){ 
      console.log("Scroll up");
      setScrollPosition(window.scrollY);
    }
    if (element) {
      window.scrollTo({
        top: element.offsetTop,
        behavior: "smooth"
      });
    }
  };
  */
  /*
  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  */


  const DayImages = () => {
    {/* 
    useTick(delta => {
      var fadeAlpha = dayAlpha;
      var cloudsFadeAlpha = cloudsAlpha;
      if(nightTime && fadeAlpha > 0){
        fadeAlpha -= delta * 0.02;
      }
      else if(!nightTime && fadeAlpha < 1){
        fadeAlpha += delta * 0.02;
      }
      setDayAlpha(fadeAlpha);
     // fade clouds first at night
     if(nightTime && cloudsFadeAlpha > 0){
      cloudsFadeAlpha -= delta * 0.04;
     }
     // then fade rest of stage
     else if(nightTime && cloudsFadeAlpha === 0){
      fadeAlpha -= delta * 0.04;
     }
     else if(!nightTime && fadeAlpha < 1){
      fadeAlpha += delta * 0.04;
     }
     else if(!nightTime && fadeAlpha === 1){
      cloudsFadeAlpha += delta * 0.04;
     }
     if(cloudsFadeAlpha < 0){
      cloudsFadeAlpha = 0;
     }
     if(cloudsFadeAlpha > 1){
      cloudsFadeAlpha = 1
     }
     if(fadeAlpha < 0){
      fadeAlpha = 0;
     }
     if(fadeAlpha > 1){
      fadeAlpha = 1
     }
     setDayAlpha(fadeAlpha);
     setCloudsAlpha(cloudsFadeAlpha);
    });
    */}

    const desktopImages = [];

    if(window.innerWidth > 800){
      desktopImages.push(<BackgroundImage image={LogoDay} x={window.innerWidth/2} y={(window.innerHeight - 80) * 0.25} anchor={0.5} width={logoWidth} height={logoHeight} alpha={dayAlpha} key="eduverse-logo-day"/>);
      desktopImages.push(<BackgroundImage image={LogoNight} x={window.innerWidth/2} y={(window.innerHeight - 80) * 0.25} anchor={0.5} width={logoWidth} height={logoHeight} alpha={1-cloudsAlpha} key="eduverse-logo-night"/>);
    }

    return(
      <>
        {desktopImages}
      </>
     );
  }

  const clickDayNight = () => {
    // Change to night time
    if(document.querySelector('.form-switch-icon').classList.contains('day')){
      document.querySelector('.form-switch-icon').classList.add('night');
      document.querySelector('.form-switch-icon').classList.remove('day');
      setNightTime(true);

      /*
      if(!document.getElementById("site-sound").classList.contains("muted")){
        document.getElementById("site-music-day").classList.add("muted");
        document.getElementById("site-music-night").classList.remove("muted");
        document.getElementById("site-music-day").pause();
        document.getElementById("site-music-night").play();
      }
      */
    }
    // Change to day time
    else{
      document.querySelector('.form-switch-icon').classList.add('day');
      document.querySelector('.form-switch-icon').classList.remove('night');
      setNightTime(false);

      if(!document.getElementById("site-sound").classList.contains("muted")){
        document.getElementById("site-music-night").classList.add("muted");
        document.getElementById("site-music-day").classList.remove("muted");
        document.getElementById("site-music-night").pause();
        document.getElementById("site-music-day").play();
      }
    }
  }

  return (
      <div className='home-page'>
        {/* Create a transparent image the size of stage so canvas can accept touch input */}
        <section className="landing-page-section" id="landing-page">
          <div className='landing-page-stage-container'>
            <div className='landing-page-stage'>
              {/*
              <div className='image-wrapper school-night'>
                <img src={SchoolNight} className='image-wrapper' alt="School Background Night"/>
                <img src={LogoNight} className='eduverse-logo' alt="EduVerse Logo Night"/>
                <Fireflies className='fireflies'/>
              </div>
              <div className='image-wrapper school-day' style={{opacity: nightTime ? 0 : 1, transition: "opacity, 2s ease-in-out"}}>
                <img src={LogoDay} className='eduverse-logo' alt="EduVerse Logo Day"/>
                <video autoPlay loop muted playsInline>
                  <source src={SchoolDayVideo}/>
                    <img src={SchoolDayImage} alt="School Day Image" title="Your browser does not support the video tag"/>
                </video>
              </div>
              <Hammer/>
              <Switch className='day-night' onClick={clickDayNight}/>
              <MoneyRain/>
              */}
            </div>
            {/*
            <button className="build-school-button" onClick={showHammer} id="build-school-button">
              <img src={require('../assets/images/Hammer_Button.png')} />
            </button>
            */}
          </div>
            
          <div className='pitch'>
            <h1 className='mt-0 mb-16 reveal-from-bottom section-header-title' data-reveal-delay='200'>
              Play2Give
            </h1>
            <h1 className='mt-0 mb-16 reveal-from-bottom section-header-title' data-reveal-delay='200'>
              Play Games, Win Prizes, Build Schools
            </h1>
          </div>
          
        </section>

        <section className='featured-games-section'>
          <div className='featured-games-list'>
            <FeaturedGameCard image={Kipon} title="Kipon" description="Casual - Free"/>
            <FeaturedGameCard image={Robotrix} title="Robotrix" description="RPG - Free"/>
            <FeaturedGameCard image={TreasureBox} title="Treasure Box" description="Adventure - Free"/>
            <FeaturedGameCard image={true} title="Explore Our Games" description="↓"/>
          </div>
        </section>
          
        <section className='about-eduverse-section'>
          <img src={Developer3} alt='Developer'/>
          <div className='about-eduverse-text-container'>
            <h1 className='mt-0 mb-16 reveal-from-bottom section-header-title' data-reveal-delay='200'>
              About EduVerse
            </h1>
            <h1 className='mt-0 mb-16 reveal-from-bottom section-header-title' data-reveal-delay='200'>
              Where Gaming Meets Charity
            </h1>
            <div>
              <p className='m-0 mb-32 reveal-from-bottom manifesto-text' data-reveal-delay='200'>
                EduVerse is a platform that bridges the gap between traditional charities and the younger generation through innovative fundraising opportunities. Our micro-transaction-based gaming system democratizes philanthropy, allowing the general public to contribute to social causes through an engaging gaming experience while providing the user opportunities to earn money through a revenue share system.
              </p>
            </div>
            <Link to='/'>
              <div className='button button-primary button-wide-mobile button-sm mint-button '>
                Learn More
              </div>
            </Link>
          </div>
          <img src={Jane} alt='Jane'/>
        </section>

        <section className='our-games-section section-inner'>
          <div className='our-games-text-container'>
            <h1 className='mt-0 mb-16 reveal-from-bottom section-header-title' data-reveal-delay='200'>
              Our Games
            </h1>
            <p className='m-0 mb-32 reveal-from-bottom manifesto-text' data-reveal-delay='200'>
              Enter the EduVerse: a universe with endless possibilities and chock full of adventure!
            </p>
          </div>
          <div className='our-games-image-container'>
            <img src={OurGames} alt='Our Games'/>
          </div>
        </section>

        <Team className="team-section" id="team" topDivider/>
        <Cta split />
      </div>
  );
}

export default Home;